import type {FormHTMLAttributes, ReactNode} from 'react';
import React from 'react';
import {classes, style} from './doppe-viewer-form.st.css';
import type {Evaluable, OmitStrict} from '@wix/devzai-utils-common';
import {evaluateWhenFunction} from '@wix/devzai-utils-common';
import {FlexLayout} from '@wix/devzai-common-client';
import {reactCreateMemo} from "@wix/devzai-utils-react";

export const DoppeViewerForm = reactCreateMemo(function DoppeViewerFormField(
    props: DoppeViewerFormField.Props
) {
    const {
        children,
        className,
        ...formAttributes
    } = props;


    const evaluatedChildren = evaluateWhenFunction(children);

    return (
        <form
            {...formAttributes}
            className={style(classes.root, {}, className, FlexLayout.column.default)}
        >
            {evaluatedChildren}
        </form>
    );
});


export namespace DoppeViewerFormField {

    export interface PartRenderProps {
        htmlId: string;
    }

    export interface Props extends OmitStrict<FormHTMLAttributes<any>, 'children'> {
        children: Evaluable<() => ReactNode>;
    }
}

